import { Layers3 } from 'lucide-react';
import GoogleGlyph from '@/src/components/ui/icons/GoogleGlyph';
import { LucideIcon } from '@/src/components/LucideIcon';
import { RedditGlyph } from './RedditGlyph';

export type ReviewSourceId = 'web' | 'google' | 'reddit';

export function ReviewsSourceIcon({ source }: { source: ReviewSourceId }) {
  if (source === 'google') return <GoogleGlyph width={16} height={16} />;
  if (source === 'reddit') return <RedditGlyph width={16} height={16} />;
  return <LucideIcon icon={Layers3} size="sm" css={{ color: 'icon.action.hero.default' }} />;
}
